import React, { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import { BookingModalProvider } from "./context/BookingModalContext";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import PageTransition from "./components/PageTransition";
import WhatsAppWidget from "./components/WhatsAppWidget";
import BookingFormModal from "./components/BookingFormModal";
import HomePage from "./pages/HomePage";
import WeddingPage from "./pages/WeddingPage";
import PrivateHirePage from "./pages/PrivateHirePage";
import FestivalPage from "./pages/FestivalPage";
import MenuPage from "./pages/MenuPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";

const AnimatedRoutes = () => {
  const location = useLocation();
  
  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<PageTransition><HomePage /></PageTransition>} />
        <Route path="/weddings" element={<PageTransition><WeddingPage /></PageTransition>} />
        <Route path="/private-hire" element={<PageTransition><PrivateHirePage /></PageTransition>} />
        <Route path="/festivals" element={<PageTransition><FestivalPage /></PageTransition>} />
        <Route path="/menu" element={<PageTransition><MenuPage /></PageTransition>} />
        <Route path="/about" element={<PageTransition><AboutPage /></PageTransition>} />
        <Route path="/contact" element={<PageTransition><ContactPage /></PageTransition>} />
        <Route path="/privacy-policy" element={<PageTransition><PrivacyPolicyPage /></PageTransition>} />
      </Routes>
    </AnimatePresence>
  );
};

function App() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <HelmetProvider>
    <BookingModalProvider>
    <div className="App bg-[#fafafa] min-h-screen">
      <BrowserRouter>
        <Navigation isScrolled={isScrolled} />
        <Toaster position="top-right" richColors />
        <AnimatedRoutes />
        <Footer />
        <WhatsAppWidget />
        <BookingFormModal />
      </BrowserRouter>
    </div>
    </BookingModalProvider>
    </HelmetProvider>
  );
}

export default App;
